import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage/LandingPage";

import EmailRegistration from "./pages/LandingPage/Authentication/EmailRegistration/EmailRegistration";
import EmailForgotPassword from "./pages/LandingPage/Authentication/EmailForgotPassword/EmailForgotPassword";
import WhatsappForgotPassword from "./pages/LandingPage/Authentication/WhatsappForgotPassword/WhatsappForgotPassword";

import WhatsappRegister from "./pages/LandingPage/Authentication/WhatsappRegister/WhatsappRegister";
import WhatsappLogin from "./pages/LandingPage/Authentication/WhatsappLogin/WhatsappLogin";
import ResetPasswordPage from "./pages/LandingPage/Authentication/ResetPasswordPage/ResetPasswordPage";
import WhatsappResetPassword from "./pages/LandingPage/Authentication/WhatsappResetPassword/WhatsappResetPassword";
import TermsOfUse from "./pages/Policies/TermsOfUse/TermsOfUse";
import CookiePolicy from "./pages/Policies/CookiePolicy/CookiePolicy";
import PrivacyPolicy from "./pages/Policies/PrivacyPolicy/PrivacyPolicy";
import MainLayout from "./pages/MainLayout/MainLayout"
import PageNotFound from "./pages/PageNotFound";
import VerifyEmailPage from "./pages/LandingPage/Authentication/EmailVerification/EmailVerification";
import PhoneNumberVerification from "./pages/LandingPage/Authentication/PhoneNumberVerification/PhoneNumberVerification";
import ManageBranchPage from "./pages/Dashboard/StoreDashboard/ManageBranchPage";
import StoreSettingsPage from "./pages/Dashboard/SideBarPages/Settings/StoreSettingsPage";
import BranchSettingsPage from "./pages/Dashboard/StoreDashboard/BranchSettingsPage";
import CustomerSupportPage from "./pages/Dashboard/StoreDashboard/CustomerSupportPage";
import DeploymentPage from "./pages/Dashboard/StoreDashboard/DeploymentPage";
import ManagePurchases from "./pages/Dashboard/StoreDashboard/ManagePurchases";
import CompleteProfileStepsPage from "./pages/Dashboard/StoreDashboard/CompleteProfileStepsPage";
import RegisterStorePage from "./pages/Dashboard/StoreDashboard/StoreRegistrationIntialisation/RegisterStorePage";
import AddBranchesPage from "./pages/Dashboard/StoreDashboard/AddBranchesPage";
import BranchesListPage from "./pages/Dashboard/StoreDashboard/BranchesListPage";
import AddProductsPage from "./pages/Dashboard/StoreDashboard/StoreRegistrationIntialisation/AddProductsPage";
import CategoriesListPage from "./pages/Dashboard/StoreDashboard/CategoriesListPage";
import AddCategoryPage from "./pages/Dashboard/StoreDashboard/AddCategoryPage";
import ProductsListPage from "./pages/Dashboard/StoreDashboard/ProductsListPage";
import IntiateDeploymentPage from "./pages/Dashboard/StoreDashboard/IntiateDeploymentPage";
import PackageSelectionPage from "./pages/Dashboard/StoreDashboard/StoreRegistrationIntialisation/PackageSelectionPage";
import PaymentFailurePage from "./pages/Dashboard/StoreDashboard/StoreRegistrationIntialisation/PaymentFailurePage";
import PaymentSuccessPage from "./pages/Dashboard/StoreDashboard/StoreRegistrationIntialisation/PaymentSuccessPage";
import BranchProductsListPage from "./pages/Dashboard/StoreDashboard/BranchProductsListPage";
import LiveChatIcon from "./components/ContactUs/LiveChatIcon";
import ActiveEnvironment from "./components/Environment/ActiveEnvironment";
import OrderDetailsPage from "./pages/Dashboard/SideBarPages/Orders/OrderDetailsPage";
import ProductOrdersPage from "./pages/Dashboard/SideBarPages/Orders/ProductOrdersPage";
import ViewMyStorePage from "./pages/Dashboard/SideBarPages/Store/ViewMyStorePage";
import DashboardPage from "./pages/Dashboard/SideBarPages/Dashboard/DashboardPage";
import MessagesPage from "./pages/Dashboard/SideBarPages/CustomerSupport/MessagesPage";
import InventoryPage from "./pages/Dashboard/SideBarPages/Inventory/InventoryPage";
import UserSettingsPage from "./pages/Dashboard/StoreDashboard/UserSettingsPage";
import PromotionsPage from "./pages/Dashboard/SideBarPages/Promotions/PromotionsPage";
import ChatWindow from "./components/Widgets/ChatBox/ChatWindow";
import AppLayout from "./Layout/AppLayout";

const Auth = lazy(() => import('./pages/LandingPage/Authentication/Auth/Auth'));



const App = () => {
  const [activePath, setActivePath] = useState("");

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div>...Loading</div>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        {/* AppLayout with policies  */}
        <Route path="/" element={<AppLayout />}>
          <Route path="/login" element={<Auth />} />
          <Route path="/email-signup" element={<EmailRegistration />} />
          <Route
            path="/forgot-password-email"
            element={<EmailForgotPassword />}
          />
          <Route
            path="/forgot-password-whatsapp"
            element={<WhatsappForgotPassword />}
          />
          <Route path="/whatsapp-register" element={<WhatsappRegister />} />
          <Route path="/whatsapp-login" element={<WhatsappLogin />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/verify-number" element={<PhoneNumberVerification />} />
          <Route path="/reset-password*" element={<ResetPasswordPage />} />
          <Route
            path="/whatsapp-forgot-password*"
            element={<WhatsappResetPassword />}
          />
        </Route>
        <Route path="/payment/failure" element={<PaymentFailurePage />} />
        <Route path="/payment/success*" element={<PaymentSuccessPage />} />
        <Route path="/view-invoices" element={<PackageSelectionPage />} />
        <Route path="/chat" element={<ChatWindow />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-of-service" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/env" element={<ActiveEnvironment />} />

        <Route path="/store" element={<MainLayout activePath={activePath} />}>
          <Route
            index
            element={<DashboardPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/view"
            element={<ViewMyStorePage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/products"
            element={<InventoryPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/orders"
            element={<OrderDetailsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/product-orders"
            element={<ProductOrdersPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/messages"
            element={<MessagesPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/settings"
            element={<StoreSettingsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/user"
            element={<UserSettingsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/coupons"
            element={<PromotionsPage setActivePath={setActivePath} />}
          />

          <Route
            path="/store/package-selection"
            element={<PackageSelectionPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/branches"
            element={<ManageBranchPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/complete/profile"
            element={<CompleteProfileStepsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/register"
            element={<RegisterStorePage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/add/new/branch/:storeId"
            element={<AddBranchesPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/add/branch/:storeId"
            element={
              <BranchesListPage
                setActivePath={setActivePath}
                header="Add Branch"
                description="Add branches for your store"
                headerActionName="Add Branch"
                headerActionNavigationLink="/store/add/new/branch"
              />
            }
          />
          <Route
            path="/store/branches/list"
            element={
              <BranchesListPage
                setActivePath={setActivePath}
                isSaveAndContinueRequired
                saveButtonNavigationLink="/store/complete/profile"
                header="Add Branch"
                description="Add branches for your store"
                headerActionName="Add Branch"
                headerActionNavigationLink="/store/addBranches"
              />
            }
          />
          <Route
            path="/store/add/categories"
            element={
              <CategoriesListPage
                setActivePath={setActivePath}
                header="Add Categories"
                description="Add Categories to your Brancheas"
              />
            }
          />
          <Route
            path="/store/branch/list/categories"
            element={
              <CategoriesListPage
                setActivePath={setActivePath}
                isSaveAndContinueRequired
                saveButtonNavigationLink="/store/complete/profile"
                header="Add Categories"
                description="Add Categories to your Brancheas"
              />
            }
          />
          <Route
            path="/store/add/new/category/:branchId"
            element={
              <AddCategoryPage
                setActivePath={setActivePath}
                header="Add Category"
                description="Add Categories to your Brancheas"
                headerActionName="Add Category"
                headerActionNavigationLink="/store/add/category"
              />
            }
          />
          <Route
            path="/store/branch/intialisation/add/products"
            element={
              <ProductsListPage
                setActivePath={setActivePath}
                header="Add Products"
                description="Add products for your branch"
              />
            }
          />
          <Route
            path="/store/branch/list/all/products/:branchId"
            element={
              <BranchProductsListPage
                setActivePath={setActivePath}
                header="View Products"
                description="View products for your branch"
              />
            }
          />
          <Route
            path="/store/intiate/deploy/:storeId"
            element={<IntiateDeploymentPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/branch/settings/:branchId"
            element={<BranchSettingsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/customer-care"
            element={<CustomerSupportPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/manage/deployments"
            element={<DeploymentPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/manage/purchases"
            element={<ManagePurchases setActivePath={setActivePath} />}
          />
          <Route
            path="/store/complete/profile"
            element={<CompleteProfileStepsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/branch/add/product/:branchId"
            element={<AddProductsPage setActivePath={setActivePath} />}
          />

          <Route
            path="/store/branch/settings/:branchId"
            element={<BranchSettingsPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/customer-care"
            element={<CustomerSupportPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/manage/deployments"
            element={<DeploymentPage setActivePath={setActivePath} />}
          />
          <Route
            path="/store/manage/purchases"
            element={<ManagePurchases setActivePath={setActivePath} />}
          />
          <Route
            path="/store/complete/profile"
            element={<CompleteProfileStepsPage setActivePath={setActivePath} />}
          />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </Suspense>
      <LiveChatIcon />
    </BrowserRouter>
  );
};

export default App;
